<div x-heatmap="" x-data="data" x-options="config" class="panel-body" style="height: 100%;">
    <svg xmlns="http://www.w3.org/2000/svg">
    </svg>
</div>
